<template>
<div class="container">
<div class="row justify-content-center mt-10">
   <div class=" col-sm-11 col-md-9 col-lg-7 col-xl-6">

      <LogoAuth/>

      <Form class="mt-10"  @submit="userLogin">

      <Field_l_fe :schema="formSchema" />

      <div class="form-group">
         <div v-if="message" class="alert alert-danger" role="alert">
            {{ message }}
         </div>
      </div>

      <div class="form-group d-grid"> <!-- d-grid gap-2"> -->
         <button type="submit" class="btn btn-primary" :disabled="loading">
            <span v-show="loading" class="spinner-border spinner-border-sm"></span>
            <font-awesome-icon icon="sign-in-alt" />
            Conectarse
         </button>
      </div>

      </Form>
      <div class="d-flex align-items-end flex-column">
         <button type="submit" class="btn btn-link" :disabled="loading" data-bs-toggle="modal" data-bs-target="#forgotPassModal">
            Olvidé mi Contraseña
         </button>
         <MdForgotPass />
      </div>
   </div>
</div>
</div>
</template>

<script>
import { Form } from "vee-validate";
import { string } from "yup";
import LogoAuth from '../components/LogoAuth.vue';
import Field_l_fe from '../components/Field-l-fe.vue';
import MdForgotPass from '../components/MdForgotPass.vue';

export default {
   name: 'Login',
   components: {
      Form,
      LogoAuth,
      Field_l_fe,
      MdForgotPass,
   },
   data() {
      return {
         successful: false,
         loading: false,
         message: "",
      };
   },
   setup() {
      const formSchema = {
         classDivCont: "form-group row mb-1",
         classLabel: "col-sm-4",
         classDivField: "d-flex align-items-end flex-column col-sm-8",
         fields: [
         {
            id: 1,
            label: 'Nombre de Usuario',
            name: 'username',
            type: 'text',
            rules: string().required("¡Se requiere nombre de usuario!"),
         },
         {
            id: 2,
            label: 'Contraseña',
            name: 'password',
            type: 'password',
            rules: string().required("¡Se requiere contraseña!"),
         },
         ],
      };
      return {
         formSchema,
      };
   },
   computed: {
      loggedIn() {
         return this.$store.state.auth.status.loggedIn;
      },
   },
   created() {
      if (this.loggedIn) {
         this.$router.push("/profile");
      }
   },
   methods: {
      userLogin(user) {
         this.loading = true;
         this.$store.dispatch("auth/login", user)
         .then( () => {
            this.$router.push("/profile");
         },
         (error) => {
            this.loading = false;
            this.message =
               (error.response &&
               error.response.data &&
               error.response.data.message) ||
               error.message ||
               error.toString();
            console.log(this.message);
            if (this.message.indexOf("401") == -1)
               this.message = "Error de sistema (Login): " + this.message;
            else
               this.message = "¡Nombre de Usuario y/o Contraseña Invalidos!";
         }
         );
      },
   },
}
</script>

<style scoped>
.spinner-border {
   margin-right: 5px;
}
</style>
